import { PaymentInfo } from "@/types/payment.type";


export const sortPaymentsByDueDate = (payments: PaymentInfo[]): PaymentInfo[] => {
  if (!payments || payments.length === 0) return [];

  return [...payments].sort((a, b) => {

    if (!a.dueDate && !b.dueDate) return 0;
    if (!a.dueDate) return 1;
    if (!b.dueDate) return -1;

    const dateA = new Date(a.dueDate);
    const dateB = new Date(b.dueDate);


    if (isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return 0;
    if (isNaN(dateA.getTime())) return 1;
    if (isNaN(dateB.getTime())) return -1;

    return dateA.getTime() - dateB.getTime();
  });
};


export const getOldestPayment = (payments: PaymentInfo[]): PaymentInfo | null => {
  const sortedPayments = sortPaymentsByDueDate(payments);
  return sortedPayments.length > 0 ? sortedPayments[0] : null;
};
